import React, { useState } from "react";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import { IP } from "../../../../internalServer";
import ZoomableImage from "../../Pending/QuestionTypes/ZoomableImage";

export default function CheckBoxType({ questionNo, response }) {
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
    setIsOpen(null)
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  return (
    <>
      <div className="containerBelowQuestion">
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. &nbsp;
            {response?.question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue">
            {response?.question?.correct_score} Marks
          </div> */}
        </div>
        {response?.question?.attachments?.length > 0 &&
          response?.question?.attachments?.map((attachment, index) => (
            <div key={index}>
              {attachment.split(".").pop() !== "mp4" ? (
                <>
                  {attachment.split(".").pop() === "jpg" ||
                    attachment.split(".").pop() === "jpeg" ||
                    attachment.split(".").pop() === "JPEG" ||
                    attachment.split(".").pop() === "JPG" ||
                    attachment.split(".").pop() === "PNG" ||
                    attachment.split(".").pop() === "png" ? (
                    <img
                      style={{ cursor: "pointer" }}
                      className="mt-3 imageWidthAndHeight"
                      src={IP + attachment?.replace(/^\./, "")}
                      alt="Attachment"
                      onClick={() => {
                        if (!isError) {
                          handleClick(attachment);
                        }
                      }}
                    />
                  ) : (
                    <div
                      key={index}
                      onClick={(e) => {
                        if (attachment.split(".").pop() === "mp3") {
                          handleClick(attachment);
                        } else {
                          setPedingSubDetail({
                            ...pedingSubDetail,
                            pdfView: true,
                            attachment: attachment,
                          });
                        }
                      }}
                      className="mt-2"
                    >
                      <div className="d-flex pdfContainer gap-2 p-2 ">
                        <div className="d-flex align-items-center">
                          <img
                            className="extention_icon"
                            src={`${iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1]
                            )?.icon
                              }`}
                            alt=""
                          />
                        </div>
                        <div className="w-100">
                          <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                            {attachment?.replace(/^[^_]*_/, "")}
                          </div>
                          <div className="pdfFileSize">12 KB</div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex pdfContainer gap-2 p-2 "
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachment);
                    }
                  }}>
                  <div className="d-flex align-items-center">
                    <img
                      className="extention_icon"
                      src={`${iconData?.find(
                        (i) =>
                          i.extension ===
                          attachment?.match(/\.([^.]+)$/)[1]
                      )?.icon
                        }`}
                      alt=""
                    />
                  </div>
                  <div className="w-100">
                    <div className="pdfName" title={attachment?.replace(/^[^_]*_/, "")}>
                      {attachment?.replace(/^[^_]*_/, "")}
                    </div>
                    <div className="pdfFileSize">12 KB</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        <div className=" optionContainer mt-4 ml-2">
          {response?.question?.options?.length > 0 &&
            response?.question?.options?.map((option, index) => {
              return (
                <>
                  <div
                    key={option.key}
                    className="d-flex justify-content-between align-items-center mt-2"
                  >
                    <div className="d-flex gap-3 ">
                      <div>
                        {
                          option?.key + ".  "
                        }
                        <input
                          type="checkbox"
                          className="hwCheckbox ml-1"
                          readOnly
                          checked={option?.key === response?.answer?.key}
                        />
                      </div>
                      <div
                        className={` ${option?.key === response?.answer?.key
                          ? "QueOptionsChecked"
                          : "QueOptions"
                          }`}
                      >
                        {option?.value}
                      </div>
                    </div>
                    {option?.key === response?.answer?.key && (
                      <div className="yourAnswer">Your answer</div>
                    )}
                  </div>
                  <div className="ml-6">
                    {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()}
                  </div>
                </>
              )
            })}
        </div>
      </div>
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>

                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
